const user = JSON.parse(window.localStorage.getItem('user'));

export const platformNavigations = [
  { name: 'Dashboard', path: '/super-admin/dashboard', icon: 'dashboard' },
  { label: 'PLATFORM MANAGEMENT', type: 'label' },
  { name: 'Companies', path: '/super-admin/companies', icon: 'business' },
  { name: 'Subscriptions', path: '/super-admin/subscriptions', icon: 'subscriptions' },
  { name: 'Payments', path: '/super-admin/payments', icon: 'payments' },
  { name: 'Company Issues', path: '/super-admin/issues', icon: 'report_problem' },
  { name: 'Sales Leaderboard', path: '/super-admin/leaderboard', icon: 'leaderboard' },
  { label: 'SETTINGS', type: 'label' },
  { name: 'Communication Settings', path: '/super-admin/communication-settings', icon: 'settings' },
];

export const navigations =
  user?.role === 'Customer'
    ? [
        { name: 'Dashboard', path: '/dashboard/default', icon: 'dashboard' },
        { name: 'Inbox', path: '/dashboard/inbox', icon: 'inbox' },
        {
          name: 'Bookings',
          icon: 'calendar_month',
          path: '/dashboard/customer-booking',
        },
        {
          name: 'Payment Method',
          icon: 'payments',
          children: [
            { name: 'Card', icon: 'credit_card', path: '/dashboard/payment-methods' },
            { name: 'ACH', icon: 'account_balance', path: '/dashboard/ach-payment-methods' },
          ],
        },
        {
          name: 'Appreciate Us',
          icon: 'favorite',
          path: '/dashboard/appreciate',
        },
        { name: 'Invoices', icon: 'receipt_long', path: '/dashboard/customer/invoices' },
        {
          name: 'Settings',
          icon: 'settings',
          children: [
            { name: 'Profile', icon: 'person', path: '/dashboard/settings/profile' },
            {
              name: 'Terms & Conditions',
              icon: 'description',
              path: '/dashboard/terms-and-conditions',
            },
            { name: 'Privacy Policy', icon: 'privacy_tip', path: '/dashboard/privacy-policy' },
          ],
        },
      ]
    : user?.role === 'Manager'
    ? [
        { name: 'Dashboard', path: '/dashboard/default', icon: 'dashboard' },
        { label: 'PAGES', type: 'label' },
        {
          name: 'Inbox',
          path: '/dashboard/inbox',
          icon: 'inbox',
        },
        {
          name: 'Bookings',
          icon: 'event_note',
          children: [
            {
              name: 'Booking Appointments',
              icon: 'event_available',
              path: '/dashboard/booking-appointments',
            },
          ],
        },
        {
          name: 'Dispatcher',
          path: '/dashboard/dispatcher',
          icon: 'format_list_bulleted',
        },
        {
          name: 'Customers',
          icon: 'people',
          children: [{ name: 'All Customers', icon: 'groups', path: '/dashboard/customers' }],
        },
        {
          name: 'Service Provider',
          icon: 'engineering',
          children: [
            { name: 'All Service Providers', icon: 'build', path: '/dashboard/service-providers' },
          ],
        },
        { name: 'Services', path: '/dashboard/services', icon: 'widgets' },
        {
          name: 'Pay Roll',
          icon: 'account_balance_wallet',
          children: [
            {
              name: 'Service Providers Payroll',
              icon: 'monetization_on',
              path: '/dashboard/service-provider-payroll',
            },
            {
              name: 'Payments',
              icon: 'payments',
              path: '/dashboard/Payments',
            },
          ],
        },
        {
          name: 'Payments',
          icon: 'assessment',
          children: [
            {
              name: 'Customers Outstanding',
              icon: 'account_balance_wallet',
              path: '/dashboard/outstanding-customers',
            },
            { name: 'Bookings Outstanding', icon: 'assignment', path: '/dashboard/reports' },
            {
              name: 'Stripe Charges ',
              icon: 'credit_card',
              path: '/dashboard/stripe-payments',
            },
            { name: 'Invoice', icon: 'receipt_long', path: '/dashboard/invoice' },
            {
              name: 'Incoming Bookings',
              icon: 'date_range',
              path: '/dashboard/booking-creation-date',
            },
          ],
        },
        {
          name: 'Settings',
          icon: 'settings',
          children: [
            { name: 'Company Profile', icon: 'business', path: '/dashboard/company' },
            { name: 'Tax', icon: 'calculate', path: '/dashboard/tax' },
            {
              name: 'Terms & Conditions',
              icon: 'description',
              path: '/dashboard/terms-and-conditions',
            },
            { name: 'Privacy Policy', icon: 'privacy_tip', path: '/dashboard/privacy-policy' },
          ],
        },
      ]
    : [
        { name: 'Dashboard', path: '/dashboard/default', icon: 'dashboard' },
        { label: 'PAGES', type: 'label' },
        {
          name: 'Inbox',
          path: '/dashboard/inbox',
          icon: 'inbox',
        },
        {
          name: 'Bookings',
          icon: 'event_note',
          children: [
            {
              name: 'Booking Appointments',
              icon: 'event_available',
              path: '/dashboard/booking-appointments',
            },
          ],
        },
        {
          name: 'Dispatcher',
          path: '/dashboard/dispatcher',
          icon: 'format_list_bulleted',
        },
        {
          name: 'Calendar',
          path: '/dashboard/calendar',
          icon: 'event',
        },
        {
          name: 'Customers',
          icon: 'people',
          children: [{ name: 'All Customers', icon: 'groups', path: '/dashboard/customers' }],
        },
        {
          name: 'Service Provider',
          icon: 'engineering',
          children: [
            { name: 'All Service Providers', icon: 'build', path: '/dashboard/service-providers' },
          ],
        },
        {
          name: 'Managers',
          icon: 'business_center',
          children: [{ name: 'All Managers', icon: 'badge', path: '/dashboard/managers' }],
        },
        { name: 'Services', path: '/dashboard/services', icon: 'widgets' },
        {
          name: 'Pay Roll',
          icon: 'account_balance_wallet',
          children: [
            {
              name: 'Service Providers Payroll',
              icon: 'monetization_on',
              path: '/dashboard/service-provider-payroll',
            },
            {
              name: 'Payments',
              icon: 'payments',
              path: '/dashboard/Payments',
            },
          ],
        },
        {
          name: 'Payments',
          icon: 'assessment',
          children: [
            {
              name: 'Customers Outstanding',
              icon: 'account_balance_wallet',
              path: '/dashboard/outstanding-customers',
            },
            { name: 'Bookings Outstanding', icon: 'assignment', path: '/dashboard/reports' },
            {
              name: 'Stripe Charges',
              icon: 'credit_card',
              path: '/dashboard/stripe-payments',
            },
            { name: 'Invoice', icon: 'receipt_long', path: '/dashboard/invoice' },
            {
              name: 'Incoming Bookings',
              icon: 'date_range',
              path: '/dashboard/booking-creation-date',
            },
          ],
        },
        {
          name: 'Email Marketing',
          icon: 'mail_outline',
          children: [
            { name: 'Users', icon: 'people', path: '/dashboard/users-list' },
            { name: 'Send Email', icon: 'send', path: '/dashboard/send-email' },
            {
              name: 'Email Templates',
              path: '/dashboard/email-templates',
              icon: 'description',
            },
          ],
        },
        {
          name: 'Settings',
          icon: 'settings',
          children: [
            { name: 'Company Profile', icon: 'business', path: '/dashboard/company' },
            {
              name: 'Email Template',
              path: '/dashboard/email-template',
              icon: 'email',
            },
            { name: 'Tax', icon: 'calculate', path: '/dashboard/tax' },
            { name: 'Service Area', icon: 'map', path: '/dashboard/restrictions' },
            { name: 'Frequency', icon: 'schedule', path: '/dashboard/frequency' },
            { name: 'Deals & Offers', icon: 'local_offer', path: '/dashboard/deals' },
            { name: 'Promo', icon: 'sell', path: '/dashboard/promo' },
            { name: 'Gift cards', icon: 'card_giftcard', path: '/dashboard/gift-cards' },
            {
              name: 'Terms & Conditions',
              icon: 'description',
              path: '/dashboard/terms-and-conditions',
            },
            { name: 'Privacy Policy', icon: 'privacy_tip', path: '/dashboard/privacy-policy' },
            { name: 'Sitemap', icon: 'account_tree', path: '/dashboard/sitemap' },
          ],
        },
      ];
